import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { RxCross2 } from "react-icons/rx";
import { useContext } from "react";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import CommonButton from "../../components/common/CommonButton";
import ReactSelector from "../../components/common/CommonReactSelector";

const UpdateRoleModal = ({
  open,
  onClose,
  form,
  setForm,
  orgOptions,
  isSuperAdmin,
  onSave,
  loading,
}) => {
  const { theme, langMode } = useContext(AppContext);
  const inputClass = `w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : "border-gray-300"}`;
  const labelClass = "block text-sm font-medium text-gray-700 dark:text-white mb-1";

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75" />
        </Transition.Child>
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
              <Dialog.Panel className={`relative rounded-2xl bg-white shadow-xl sm:max-w-lg w-full ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""}`}>
                <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
                  <Dialog.Title className="text-lg font-semibold">{translations[langMode].updateRole}</Dialog.Title>
                  <button type="button" className="text-gray-400 hover:text-gray-600" onClick={onClose}>
                    <RxCross2 size={20} />
                  </button>
                </div>
                <div className="px-5 py-6 space-y-4">
                 
                  <div>
                    <label className={labelClass}>{translations[langMode].roleName}</label>
                    <input
                      type="text"
                      value={form.roleName}
                      onChange={(e) => setForm((f) => ({ ...f, roleName: e.target.value }))}
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label className={labelClass}>{translations[langMode].description}</label>
                    <textarea
                      value={form.description}
                      onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
                      className={inputClass}
                      rows={3}
                    />
                  </div>
                </div>
                <div className="flex justify-end items-center gap-3 px-5 py-4 border-t border-gray-200">
                  <CommonButton variant="danger" onClick={onClose}>{translations[langMode].cancle || "Cancel"}</CommonButton>
                  <CommonButton variant="primary" onClick={onSave} disabled={loading}>{translations[langMode].save}</CommonButton>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default UpdateRoleModal;
